module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/2_2cc32457adb00ae7e743940c310e2488.png";